// extracted by mini-css-extract-plugin
export default {"badge":"badge_f742920acc1e9f60df6b"};